import { DebugView as SrvgDebugView, ModelUpdateEvent, SimpleModel, Setup,
         SetupView, View, Size, Position, Controller, ViewController } from "@gaming/srvg-classes-core";
import { PhaseChangeEvent } from "../Event/PhaseChangeEvent";

export class DebugView extends SrvgDebugView {
    lastPhaseChangeEvent: PhaseChangeEvent;
    subscribedSetupModel: SimpleModel<Setup>;

    registerEventHandlers() {
        super.registerEventHandlers();
        app.timelineController.addSubscriberForEvent( this, PhaseChangeEvent  );
    }

    refreshInfoView() {
        var $periodView = $(this.selector+' .currentperiod');

        if( ! this.subscribedSetupModel ) {
            if( app && app.view && app.view.currentSetupModel ) {
                app.view.currentSetupModel.addSubscriberForEvent( this, ModelUpdateEvent )
                this.subscribedSetupModel = app.view.currentSetupModel;
            }
        }

        if ($periodView.length) {
            var html = '';
            html += 'Current channel: <strong>' + app.timeline.currentChannel + '</strong><br>';
            if( this.lastPhaseChangeEvent ) {
                html += 'Current competition_nr: <strong>' + this.lastPhaseChangeEvent.chunk.competition.nr + '</strong><br>';
                html += 'Current stage: <strong>' + this.lastPhaseChangeEvent.chunk.competitionStageType + '</strong><br>';
                html += 'Current chunk_nr: <strong>' + this.lastPhaseChangeEvent.chunk.nr + '</strong><br>';
                html += 'Current chunk description: <strong>' + this.lastPhaseChangeEvent.chunk.getName() + ' ' + this.lastPhaseChangeEvent.chunk.getDescription() + '</strong><br>';
                html += 'Current matchset_nr: <strong>' + this.lastPhaseChangeEvent.chunk.matches[app.timeline.currentChannel].matchset.nr + '</strong><br>';
                html += 'Current match_id: <strong>' + this.lastPhaseChangeEvent.chunk.matches[app.timeline.currentChannel].id + '</strong><br>';
                html += 'Current phase: <strong>' + this.lastPhaseChangeEvent.phase.name + '</strong><br>';
            }
            else {
                html += 'Current phase: <strong>not available yet</strong><br>';
            }
            if( app.view.currentSetupModel && app.view.currentSetupModel.value ) {
                html += 'Current setup: <strong id="currentSetupName">' + app.view.currentSetupModel.value.name + '</strong><br>';
            }
            $periodView.html(html);
            $periodView.stop(true,true).animate({backgroundColor: '#cbdb1e'}, 300);
            setTimeout(function() {$periodView.stop(true,true).animate({backgroundColor: 'transparent'}, 300); },300);
        }
    }

    showPostMatchOverlay() {
        if (app.viewController && app.viewController.videoAreaViewController.overlayContainerContainerViewController.timelineOverlayContainerViewController){
            app.viewController.videoAreaViewController.overlayContainerContainerViewController.timelineOverlayContainerViewController.handlePhaseChangeEvent({phase: {name: "post_match", start: 80, end: 110}, chunk: 1, serverDatetime: 100}, this);
        }else{
            $('#timelineOverlayContainerView').removeClass('hidden').attr('data-phase-name', 'post_match');
        }
    }

    showPreMatchOverlay(stageTypeId?){
        stageTypeId = stageTypeId || 'leaque';
        if (app.viewController && app.viewController.videoAreaViewController.overlayContainerContainerViewController.timelineOverlayContainerViewController) {
            app.viewController.videoAreaViewController.overlayContainerContainerViewController.timelineOverlayContainerViewController.handlePhaseChangeEvent({
                phase: {name: "pre_match", start: 80, end: 110},
                chunk: {competitionStageType: stageTypeId}, serverDatetime: 100
            }, this);
        }else{
            $('#timelineOverlayContainerView').removeClass('hidden').attr('data-phase-name', 'pre_match');
        }
    }

    showPostCupOverlay(){
        if (app.viewController && app.viewController.videoAreaViewController.overlayContainerContainerViewController.timelineOverlayContainerViewController){
            app.viewController.videoAreaViewController.overlayContainerContainerViewController.timelineOverlayContainerViewController.handlePhaseChangeEvent({phase: {name: "post_cup", start: 80, end: 110}, chunk: 6, serverDatetime: 100}, this);
        }else{
            $('#timelineOverlayContainerView').removeClass('hidden').attr('data-phase-name', 'post_cup');
        }
    }

    showPostGroupOverlay(){
        if (app.viewController && app.viewController.videoAreaViewController.overlayContainerContainerViewController.timelineOverlayContainerViewController){
            app.viewController.videoAreaViewController.overlayContainerContainerViewController.timelineOverlayContainerViewController.handlePhaseChangeEvent({phase: {name: "post_group", start: 80, end: 200}, chunk: 9, serverDatetime: 100}, this);
        }else{
            $('#timelineOverlayContainerView').removeClass('hidden').attr('data-phase-name', 'post_group');
        }
    }

    showPostLeagueOverlay(){
        if (app.viewController && app.viewController.videoAreaViewController.overlayContainerContainerViewController.timelineOverlayContainerViewController){
            app.viewController.videoAreaViewController.overlayContainerContainerViewController.timelineOverlayContainerViewController.handlePhaseChangeEvent({phase: {name: "post_league", start: 80, end: 110}, chunk: 6, serverDatetime: 100}, this);
        }else{
            $('#timelineOverlayContainerView').removeClass('hidden').attr('data-phase-name', 'post_league');
        }
    }
    hideOverlay() {
        if (app.viewController && app.viewController.videoAreaViewController.overlayContainerContainerViewController.timelineOverlayContainerViewController) {
            app.viewController.videoAreaViewController.overlayContainerContainerViewController.timelineOverlayContainerViewController.handlePhaseChangeEvent({
                phase: {name: "match_video", start: 80, end: 110},
                chunk: 1, serverDatetime: 100
            }, this);
        }else{
            $('#timelineOverlayContainerView').addClass('hidden').attr('data-phase-name', 'match_video');
        }
    }

    applySetup( setupName: string ) {
        //app.view.hideSetupViews( false );
        app.view.setCurrentSetupByName( setupName );
        //app.view.showSetupViews( true );
    }

    showVfecDebugbox(){
        function getViewTreeDom( view:View ) {
            if (!view){
                console.error("view is not set. view value:", view);
                return;
            }

            var $li = $('<li class="' + (view.isExpanded?'expanded':'') + '"/>');

            // TODO <span class="expandButton"></span>

            var expander = $('<span class="expandButton"></span>')
                .appendTo($li)
                .mouseenter( function() {
                    view.jQuery().addClass( 'debugHighlight' );
                } )
                .mouseleave( function() {
                    view.jQuery().removeClass( 'debugHighlight' );
                } );

            if( view.subViews.length ) {
                expander.click( function() {
                    view.isExpanded = ! view.isExpanded;
                    $li.toggleClass( 'expanded' );
                } );
            }
            else {
                expander.addClass( 'disabled' );
            }

            var a = $('<span class="name" title="' + view.selector + '">' + view.name + '</span> <span class="objectId">#' + view.objectId + '</span>')
                .appendTo( $li )
                .addClass( 'link' )
                .mouseenter( function() {
                    view.jQuery().addClass( 'debugHighlight' );
                } )
                .mouseleave( function() {
                    view.jQuery().removeClass( 'debugHighlight' );
                } )
                .click( function() {
                    view.logEvents = ! view.logEvents;
                    view.logToConsole = ! view.logToConsole;
                    a.toggleClass( 'active' );
                    if( a.hasClass( 'active' ) ) {
                        console.log( view );
                    }
                } );
            if( view.subViews.length ) {
                var ul = $('<ul/>').appendTo($li);
                view.subViews.forEach( function( el ) {
                    ul.append( getViewTreeDom( el ) );
                } );
            }
            return $li;
        }

        var viewControllers = [];

        function getViewControllerTreeDom( controller:ViewController ) {
            if (!controller){
                console.error("controller is not set. controller value:", controller);
                return;
            }
            viewControllers.push( controller );
            var li = $('<li class="expanded"/>')
            var a = $('<div/>')
                .appendTo( li )
                .addClass( 'link' )
                .html( controller.name + ' <span class="objectId">#' + controller.objectId + '</span>' )
                .click( function() {
                    controller.logEvents = ! controller.logEvents;
                    controller.logToConsole = ! controller.logToConsole;
                    a.toggleClass( 'active' );
                    if( a.hasClass( 'active' ) ) {
                        console.log( controller );
                    }
                } );
            if( controller.childViewControllers.length ) {
                var ul = $('<ul/>').appendTo(li);
                controller.childViewControllers.forEach( function( el ) {
                    ul.append( getViewControllerTreeDom( el ) );
                } );
            }
            return li;
        }

        function getControllerDom( controller:Controller ) {
            var li = $('<li class="expanded"/>')
            var a = $('<div/>')
                .appendTo( li )
                .addClass( 'link' )
                .html( controller.name + ' <span class="objectId">#' + controller.objectId + '</span>' )
                .click( function() {
                    controller.logEvents = ! controller.logEvents;
                    controller.logToConsole = ! controller.logToConsole;
                    a.toggleClass( 'active' );
                    if( a.hasClass( 'active' ) ) {
                        console.log( controller );
                    }
                } );
            return li;
        }

        var setupOptions = '';
        if( app.view && app.view.currentSetupModel && app.view.currentSetupModel.value ) {
            // No overlays when we have screen setups
            $('#show_overlays').hide();
            $('#hide_overlays').hide();

            setupOptions += '<div><strong>Apply Setup:</strong></div>' + '<ul>';
            var setupNames = Object.getOwnPropertyNames( app.view.setups).sort();
            for( var i = 0; i < setupNames.length; i++ ) {
                var setupName = setupNames[i];
                setupOptions += '<li style="margin-bottom:4px;position:relative;">';
                setupOptions += '<a href="javascript:srvg.debugView.applySetup(\'' +  setupName + '\');">';
                setupOptions += '<canvas id="setupView_' + i + '" class="View SetupView"></canvas>';
                setupOptions += '<span style="position:absolute;left:85px;top:15px;">' + setupName + '</span>';
                setupOptions += '</a>';
                setupOptions += '</li>';
            }
            setupOptions += '</ul>';
        }
        $('#ViewControllerTree > ul').html('').append( getViewControllerTreeDom(app.viewController) );
        var $controllerList = $('#ControllerList > ul').html('');
        srvg.controllers.forEach( function( controller ) {
            if( viewControllers.indexOf( controller ) == -1 ) {
                $controllerList.append( getControllerDom( controller ) );
            }
        } );
        $('#ViewTree > ul').html('').append( getViewTreeDom(app.view) );
        $('#apprevision').html(  app.revision + ' ' + app.name );
        if( setupOptions ) {
            $('#setupoptions').html( setupOptions );

            if( app.view && app.view.currentSetupModel && app.view.currentSetupModel.value ) {
                var setupNames = Object.getOwnPropertyNames( app.view.setups).sort();
                for( var i = 0; i < setupNames.length; i++ ) {
                    var setupName = setupNames[i];
                    var setupView = new SetupView( { selector: '#setupView_' + i, setup: app.view.setups[setupName] } );
                    this.addSubView( setupView );
                    setupView.setDimensions( new Position( 0, 0 ), new Size( 80, 45 ) );
                    setupView.refresh();
                }
            }
        }

        this.refreshInfoView();
        this.show();
    }
    //---

    // ------------------------ event handlers ------------------------

    handlePhaseChangeEvent(event: PhaseChangeEvent){
        this.lastPhaseChangeEvent = event;
        this.refreshInfoView();
    }

    handleModelUpdateEvent( event:ModelUpdateEvent, provider ) {
        this.refreshInfoView();
    }
}